import { render, staticRenderFns } from "./batch-limit-list.vue?vue&type=template&id=06aaec49"
import script from "./batch-limit-list.vue?vue&type=script&lang=js"
export * from "./batch-limit-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports